import { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { parseJSON_ifParsable } from 'utils/objectManipulate';
import { gameTypes } from 'config/promoGameTypes';

// 控制有開設定全對的獎品
const usePrizeRuleChecker = ({ entryUuid } = {}) => {
    /* 給獎優化: 能夠領取獎品邏輯
     * 1. 翻牌遊戲，全對才能領取獎品(有開全對設定) + 有資格領取獎品
     * 2. 翻牌遊戲，全對/沒全對才能領取獎品(沒開全對設定) + 有資格領取獎品
     * 3. 問答遊戲，全對才能領取獎品
     * 4. 問答遊戲，全對才能領取獎品
     */

    const {
        lotteryParticipant = {},
        lotteryInstant = {},
        userGameResultRecords,
        promo
    } = useSelector(s => ({
        lotteryParticipant: s.lotteryParticipant,
        lotteryInstant: s.lotteryInstant,
        userGameResultRecords: s.userGameResultRecords,
        promo: s.promo
    }));

    const currentEntryRecord = userGameResultRecords.find(r => r.uuid === entryUuid);

    const currentGameResult = useMemo(() => {
        if (userGameResultRecords.length <= 0) return {};
        return currentEntryRecord ? parseJSON_ifParsable(currentEntryRecord?.gameResult) : {};
    }, [currentEntryRecord, userGameResultRecords.length]);

    const isLotteryParticipantRequiredAllCorrect = !!lotteryParticipant?.TasksSetting?.uuid;
    const isLotteryInstantRequiredAllCorrect = !!lotteryInstant?.TasksSetting?.uuid;

    // 確認是否動畫獎已配獎給此 entry
    const checkIsUserHaveClaimedParticipantPrize = entryRecord => {
        return Boolean(entryRecord?.flow?.lotteryParticipant);
    };
    // 確認是否即時獎已配獎給此 entry
    const checkIsUserHaveClaimedInstantPrize = entryRecord => {
        return Boolean(entryRecord?.flow?.lotteryInstant);
    };

    const checkIsGameChallengeAllCorrect = useCallback(({ type, gameResult = {} }) => {
        switch (type) {
            case gameTypes.QUIZ:
                // [#86ep582up]
                return gameResult?.wrongTotal !== undefined && Number(gameResult?.wrongTotal) === 0;
            case gameTypes.MEMORY_MATCH:
                // [#86ep582v1] 這邊的成功其實不是錯誤次數是0，而是挑戰成功（在秒數內、且沒超過翻錯次數）
                return gameResult?.status !== undefined && Number(gameResult?.status) === 1;
            default:
                return true;
        }
    }, []);

    // #86erkacx7: 針對全對才能給獎的活動，修正是否可以領獎的條件 (讓領獎按鈕在對的時機與條件顯示)
    const canClaimPrize = (isRequiredAllCorrect = false, isGameAllCorrect = false) => {
        return isRequiredAllCorrect ? isGameAllCorrect : true;
    };

    const isGameChallengeAllCorrect = useMemo(
        () => checkIsGameChallengeAllCorrect({ type: promo.type, gameResult: currentGameResult }),
        [checkIsGameChallengeAllCorrect, promo.type, currentGameResult]
    );

    return {
        isLotteryParticipantRequiredAllCorrect,
        isLotteryInstantRequiredAllCorrect,
        isGameChallengeAllCorrect,
        checkIsUserHaveClaimedParticipantPrize,
        checkIsUserHaveClaimedInstantPrize,
        checkIsGameChallengeAllCorrect,
        canClaimPrize
    };
};

export default usePrizeRuleChecker;
